export default "__VITE_ASSET__CgzeTDxD__"